var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8 17.7C19.9 16.9 19.5 16.1 18.9 15.6C18.2 15.1 17.3 15 16.5 15.4L13.3 12.2C13.5 11.8 13.6 11.4 13.5 11C13.4 9.69999 12.3 8.69999 10.9 8.79999L11.7 10.6L10.5 11.8L8.70001 10.9C8.60001 11.7 9.00001 12.6 9.60001 13.1C10.3 13.6 11.2 13.6 11.9 13.3L15.1 16.6C14.8 17.3 14.8 18.2 15.2 18.8C15.7 19.6 16.6 20 17.4 19.9L16.6 18.1L17.8 16.9L19.8 17.7Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9 7.3C12 7.2 13.2 7.6 14 8.5C14.9 9.4 15.3 10.8 14.9 12L16.7 13.8C17 13.8 17.3 13.7 17.6 13.7V0H6.79999V4.4H10.8V7.3H10.9ZM13.3 1.8C13.3 1.3 13.8 1.1 14.2 1V0.6H14.5V1C14.9 1 15.2 1.2 15.4 1.6L15 1.7C14.9 1.5 14.7 1.4 14.5 1.3V2.2C15 2.4 15.4 2.5 15.4 3C15.4 3.4 15 3.8 14.5 3.8V4.2H14.2V4C13.8 4 13.3 3.8 13.1 3.4L13.5 3.2C13.6 3.5 13.9 3.6 14.2 3.6V2.6C13.7 2.4 13.3 2.3 13.3 1.8ZM13.3 5.3H17C17.1 5.3 17.2 5.4 17.2 5.5C17.2 5.6 17.1 5.7 17 5.7H13.3C13.2 5.7 13.1 5.6 13.1 5.5C13.1 5.4 13.2 5.3 13.3 5.3ZM12 4.8C12.4 4.8 12.7 5.1 12.7 5.5C12.7 5.9 12.4 6.2 12 6.2C11.6 6.2 11.3 5.9 11.3 5.5C11.3 5.1 11.6 4.8 12 4.8Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 1.39999C13.9 1.39999 13.7 1.59999 13.7 1.79999C13.7 1.99999 13.9 2.09999 14.2 2.19999V1.39999Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.20001C15 3.00001 14.8 2.80001 14.5 2.70001V3.60001C14.8 3.60001 15 3.40001 15 3.20001Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29999 14.9C5.29999 14.7 5.09999 14.5 4.79999 14.4V15.3C5.09999 15.3 5.29999 15.2 5.29999 14.9Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.1C4.2 13.1 4 13.3 4 13.5C4 13.7 4.2 13.8 4.5 13.9V13.1Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3 11.2H0.8V10.6H7.4C7.5 10.1 7.7 9.59999 7.9 9.19999L9.4 9.99999V5.79999H0V19.5H9.4V14.6C8.1 13.9 7.3 12.6 7.3 11.2ZM3.6 13.5C3.6 13 4.1 12.8 4.5 12.7V12.3H4.8V12.7C5.2 12.7 5.5 12.9 5.7 13.3L5.3 13.5C5.2 13.3 5 13.2 4.8 13.1V14C5.3 14.2 5.7 14.3 5.7 14.8C5.7 15.2 5.3 15.6 4.8 15.6V16H4.5V15.6C4.1 15.6 3.6 15.4 3.4 15L3.8 14.8C3.9 15.1 4.2 15.2 4.5 15.2V14.2C4 14.2 3.6 14 3.6 13.5ZM3 17.2C3 17.6 2.7 17.9 2.3 17.9C1.9 17.9 1.6 17.6 1.6 17.2C1.6 16.8 1.9 16.5 2.3 16.5C2.7 16.6 3 16.9 3 17.2ZM7.4 17.5H3.7C3.6 17.5 3.5 17.4 3.5 17.3C3.5 17.2 3.6 17 3.7 17H7.4C7.5 17 7.6 17.1 7.6 17.2C7.6 17.3 7.5 17.5 7.4 17.5Z",
    fill: "#60605F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8,
    height: 19.9,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetManagement);
export default __webpack_public_path__ + "static/media/Asset_Management.acef9b99042380fe9a5f61455cc91ef7.svg";
export { ForwardRef as ReactComponent };